import React from 'react';
import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton
} from 'react-share';
import { urls } from '../router/urls';
import axios from 'axios';

const ShareResourceModal = ({ resource_id, url, quote }) => {
  const shareButtonOnClickHandler = () => {
    axios.post(urls.getResourceNumberTimesSharedURL(resource_id));
  };

  return (
    <div
      className="modal fade modal-backdrop-transparent show"
      id="modal-shortcut"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modal-shortcut"
      style={{ display: 'none', paddingRight: '15px' }}
      aria-modal="true"
    >
      <div
        className="modal-dialog modal-dialog-top modal-transparent"
        role="document"
      >
        <div className="modal-content">
          <div className="modal-body">
            <ul className="app-list w-auto h-auto p-0 text-center demo">
              <li>
                <span onClick={shareButtonOnClickHandler}>
                  <FacebookShareButton url={url} quote={quote}>
                    <FacebookIcon size={60} round />
                  </FacebookShareButton>
                </span>
              </li>

              <li>
                <span onClick={shareButtonOnClickHandler}>
                  <TwitterShareButton url={url} quote={quote}>
                    <TwitterIcon size={60} round />
                  </TwitterShareButton>
                </span>
              </li>

              <li>
                <span onClick={shareButtonOnClickHandler}>
                  <WhatsappShareButton url={url} quote={quote} separator=":: ">
                    <WhatsappIcon size={60} round />
                  </WhatsappShareButton>
                </span>
              </li>

              <li>
                <span onClick={shareButtonOnClickHandler}>
                  <LinkedinShareButton url={url} quote={quote} separator=":: ">
                    <LinkedinIcon size={60} round />
                  </LinkedinShareButton>
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShareResourceModal;
